export default "__VITE_ASSET__CcMvdr5u__"